export enum AccountSystemTypes {
  AIM = "AIM",
  FORTRESS = "FORTRESS",
  RESMAN = "RESMAN",
  YARDI = "YARDI",
  REALPAGE = "REALPAGE"
};